import { createTheme } from "@mui/material/styles";

export const HR_ERP_PRIMARY = "#0891B2";
export const HR_ERP_PRIMARY_600 = "#077d9c";
export const HR_ERP_PRIMARY_700 = "#066b85";

export function createHrErpTheme(mode = "light") {
  return createTheme({
    palette: {
      mode,
      primary: {
        main: HR_ERP_PRIMARY,
        dark: HR_ERP_PRIMARY_600,
        contrastText: "#ffffff",
      },
      background: {
        default: "var(--ems-bg)",
        paper: "var(--ems-surface)",
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          containedPrimary: {
            backgroundColor: HR_ERP_PRIMARY,
            color: "#ffffff",
            "&:hover": {
              backgroundColor: HR_ERP_PRIMARY_600,
            },
            "&:disabled": {
              backgroundColor: "rgba(8, 145, 178, 0.45)",
              color: "#ffffff",
            },
          },
        },
      },
      MuiLoadingButton: {
        styleOverrides: {
          root: {
            "&.MuiButton-containedPrimary": {
              backgroundColor: HR_ERP_PRIMARY,
              "&:hover": {
                backgroundColor: HR_ERP_PRIMARY_600,
              },
            },
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          variant: "outlined",
        },
      },
      MuiFormControl: {
        defaultProps: {
          variant: "outlined",
        },
      },
    },
  });
}
